import type { ICountryObject } from "app/services/CountryService";

const matchesText = (text: string | undefined, term: string): boolean =>
    Boolean(text?.toLowerCase().includes(term));

/**
 * Region-aware country search predicate. Replicates the legacy CountriesDropdown `handleSearch`:
 * a country matches when its own name matches the term OR when any of its nested region/child
 * entries (`states` / `children`) match — so searching a state name surfaces its parent country.
 * The term is expected to be already lower-cased (SelectCombobox lower-cases before calling).
 */
export const filterCountryItem = (country: ICountryObject, term: string): boolean => {
    if (matchesText(country.text, term)) {
        return true;
    }

    const nested = [...(country.states ?? []), ...(country.children ?? [])];

    return nested.some((child) => matchesText(child.text, term));
};
